import { IconDefinition, library } from "@fortawesome/fontawesome-svg-core";
import { ClientUIConfiguration, getClientConfiguration } from "../../configuration";

export const setClientUIConfiguration = (uiConfiguration: ClientUIConfiguration, icons: IconDefinition[]) => {
  const clientConfiguration = getClientConfiguration();
  // If the Client Configuration was resolved from the window, or has otherwise been set...
  if (clientConfiguration) {
    clientConfiguration.ui = uiConfiguration;
  }
  // If there are icons to add to the library...
  if (icons.length) {
    library.add(...icons);
  }
};
